{
  "beverageIds": [
    "beverage",
    "beverage2",
    "beverage3",
    "beverage4",
    "beverage5",
    "beverage6",
    "beverage7",
    "beverage-split"
  ],
  "passionIds": [
    "follow",
    "share",
    "share2",
    "share3",
    "golf",
    "video",
    "video3",
    "interactive",
    "bubbles",
    "bubbles2",
    "bubbles3",
    "visual",
    "derived-visual",
    "travel",
    "passions-hub",
    "passion-profile",
    "consent",
    "offers"
  ]
}
